// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__20uz5","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__3fi-I"};